export const FILTER_ENTERTAINMENT = 'filter_entertainment_urn';
export const FILTER_WEBSITE_ENTERTAINMENT = 'filter_website_entertainment_urn';
export const LIST_ITEMS_PER_PAGE = 'list_items_per_page';